<template>
    <scroll-bar>
      <!-- openeds -->
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
    :collapse="isCollapse"
      background-color="#0b1b39"
      text-color="#333333"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>
<script>
import ScrollBar from "@/components/ScrollBar"
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'
export default {
    components:{
        SidebarItem,
        ScrollBar
    },
    created(){
     
    },
    computed:{
        ...mapGetters([
            'sidebar'
        ]),
        routes(){
            return this.$router.options.routes
        },
        isCollapse(){
            return !this.sidebar.opened
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue